export enum VoucherType {
    GIFT_VOUCHER = 'GIFT_VOUCHER',
    LOYALTY_CARD = 'LOYALTY_CARD',
    DISCOUNT_VOUCHER = 'DISCOUNT_VOUCHER',
}
